import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MemoryBook {
  id: string;
  title: string;
  unfinished_comments: number;
  total_comments: number;
  status: "not_started" | "in_progress" | "completed";
  online_comments?: number;
  physical_comments?: number;
  thumbnail?: string;
  assignmentId?: number; 
  assignedAt?: string;
  dueDate?: string;
}

interface MemoryBookState {
  selectedBook: MemoryBook | null;
  dailyGoal: number;
  actualScanned: number;
  showLoginModal: boolean;
}

const initialState: MemoryBookState = {
  selectedBook: null,
  dailyGoal: 0,
  actualScanned: 0,
  showLoginModal: false,
};

const memoryBookSlice = createSlice({
  name: "memoryBook",
  initialState,
  reducers: {
    setSelectedBook: (state, action: PayloadAction<MemoryBook | null>) => {
      state.selectedBook = action.payload;
    },
    setDailyGoal: (state, action: PayloadAction<number>) => {
      state.dailyGoal = action.payload;
    },
    setActualScanned: (state, action: PayloadAction<number>) => {
      state.actualScanned = action.payload;
    },
    setShowLoginModal: (state, action: PayloadAction<boolean>) => {
      state.showLoginModal = action.payload;
    },

    resetMemoryBookState: (state) => {
      state.selectedBook = null;
      state.dailyGoal = 0;
      state.actualScanned = 0;
      state.showLoginModal = false;
    },
    updateScannedComments: (
      state,
      action: PayloadAction<{ scanned: number }>,
    ) => {
      if (!state.selectedBook) return;

      const newUnfinished = Math.max(
        state.selectedBook.unfinished_comments - action.payload.scanned,
        0,
      );

      state.selectedBook = {
        ...state.selectedBook,
        unfinished_comments: newUnfinished,
        status: newUnfinished === 0 ? "completed" : "in_progress",
      };
    },
  },
});

export const {
  setSelectedBook,
  setDailyGoal,
  setActualScanned,
  setShowLoginModal,
  resetMemoryBookState,
  updateScannedComments,
} = memoryBookSlice.actions;

export default memoryBookSlice.reducer;
